import { Phone } from "../../src/components/phoneUI/PhoneClass";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { extras, images } from "./images";
import { V8VanessaNaughtySmsAfter } from "./V8";
import { doSmsSound } from "../helpers/helpers";

export const V8VanessaNaughtySms = async (): Promise<any> => {
   
    doSmsSound();
    if (mc.properties.gotKissedByEmily) {
        mc.talk(`Now what?!`);
    }

    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `I'M SOOOO FUCKING HORNY! CAN I HAVE A PASS?`, options: { wait: false } });
        if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario) {
            await Phone.setMessage({ character: mc.character, text: `WTF? I already gave you one!`, options: { wait: true } });

        } else {
            await Phone.setMessage({ character: mc.character, text: `Nice try! No passes.`, options: { wait: true } });
        }
        await Phone.setImage({ ...images.v8.VanessaDildo_0, character: vanessa.character });
        Phone.setMessage({ character: vanessa.character, text: `PLEASEEEEEE`, options: { wait: false } });
        await Phone.setQuestion({
            character: vanessa.character, question: new Question({ text: `PLEASEEEEEE`, options: { think: false, wait: false }, key: `v8LetVanessaPlayWithDildo` })
                .option({ title: `Agree`, key: true })
                .option({ title: `Don't agree`, key: false })
        });
        if (Question.globalAnswers.v8LetVanessaPlayWithDildo) {
            Phone.setMessage({ character: mc.character, text: `Oh... That... Sure why not... go wild.` });
            Phone.setMessage({ character: vanessa.character, text: `REALLY?!`, options: { wait: true } });
            await Phone.setMessage({ character: vanessa.character, text: `Me and Mr. Sweet are sending our love 💋💋` });
            Phone.setImage({ ...images.v8.VanessaDildo_4, character: vanessa.character, options: { wait: false } });


        } else {
            Phone.setMessage({ character: mc.character, text: `Nope! Not even that!` });
            await Phone.setImage({ ...images.v8.VanessaDildo_1, character: vanessa.character });
            Phone.setMessage({ character: vanessa.character, text: `Is this allowed?`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `No!` });

            Phone.setMessage({ character: vanessa.character, text: `Ok... And what about...` });
            await Phone.setMessage({ character: vanessa.character, text: `This?` });
            Phone.setImage({ ...images.v8.VanessaDildo_2, character: vanessa.character, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Nope.` });
            Phone.setMessage({ character: vanessa.character, text: `FUCK!` });
            await Phone.setMessage({ character: vanessa.character, text: `What about this? It doesn't really touch my pussy!` });
            Phone.setImage({ ...images.v8.VanessaDildo_3, character: vanessa.character, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `...` });
            Phone.setMessage({ character: vanessa.character, text: `Fine! Fuck you! Good night! 😡` });

        }

        Phone.closeMessagesUI();
    });

    return jump(V8VanessaNaughtySmsAfter, "V8VanessaNaughtySmsAfter");
};